<template>
  <div>
    <van-popup v-model="visible" position="bottom" :style="{ height: '60%' }">
      <div class="store-select">
        <div class="picker-header">
          <div class="cancel-btn" @click="close">{{ $t('button.cancel') }}</div>
          <div class="title">{{ $t('shared.title.selectPlan') }}</div>
          <div class="confirm-btn"></div>
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('tips.noMore')"
          @load="onLoadStore"
          class="store-list-container"
        >
          <van-cell
            v-for="item in storeList"
            :key="item.id"
            :title="item.customerName"
            clickable
            @click="onConfirmStore(item)"
          >
            <template #title>
              <div class="store-main-content">
                <div class="plan-name van-ellipsis">{{ item.planName }}</div>
                <div class="plan-info van-ellipsis">{{ item.customerCount }} {{ $t('shared.stores') }}、{{ item.sdCount }} {{ $t('shared.distributor') }}</div>
                <!-- 计划拜访日期 -->
                <div class="plan-date van-ellipsis">{{ $t('shared.plannedVisitDate') }}：{{ item.planTime }}</div>
              </div>
            </template>
          </van-cell>
        </van-list>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { visitPlanListPageApi } from '@/api/visitPlan'
import i18n from '@/i18n'
export default {
  name: 'XuPlanSelect',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    pageType: {
      type: String,
      default: ''
    },
    currentGroup: {
      type: Object,
      default: () => {}
    },
    apiType: {
      type: [String, Number],
      default: ''
    },
    currentPlanInfo: {
      type: Object,
      default: () => {}
    }
  },
  filters: {
    formatTag (value) {
      return value === 0 ? i18n.t('shared.filter.toBeVerified') : value === 1 ? i18n.t('shared.filter.sVIPCore') : value === 2 ? i18n.t('shared.filter.vIPCore') : value === 3 ? i18n.t('shared.filter.potential') : ''
    },
    formatTagClass (value) {
      return `tag${value}`
    }
  },
  data () {
    return {
      visible: this.value,
      loading: false,
      finished: false,
      page: 1,
      pageSize: 20,
      storeList: [],
      timer: null,
      radioVal: '',
      qrcodeUrl: null,
      checkedList: []
    }
  },
  watch: {
    value (val) {
      this.visible = val
      if (val) {
        // Reset when opening
        this.page = 1
        this.finished = false
        this.storeList = []
        this.checkedList = []
        this.loading = true // Set loading true initially to prevent immediate finish
        this.onLoadStore()
      }
    },
    visible (val) {
      if (!val) {
        this.radioVal = ''
        this.qrcodeUrl = null
      }
      this.$emit('input', val)
    }
  },
  methods: {
    close () {
      this.visible = false
    },
    async onLoadStore () {
      try {
        const res = await visitPlanListPageApi({
          page: this.page,
          limit: this.pageSize,
          targetId: this.currentPlanInfo.targetId || '',
          targetType: this.currentPlanInfo.targetType || '',
          excludeTarget: true
        })
        if (this.page === 1) {
          this.storeList = res.data.list
        } else {
          this.storeList = [...this.storeList, ...res.data.list]
        }

        this.loading = false

        if (this.storeList.length >= Number(res.data.totalRow)) {
          this.finished = true
        } else {
          this.page++
        }
      } catch (error) {
        this.loading = false
        this.finished = true
      }
    },
    onConfirmStore (item) {
      this.$emit('confirm', item)
      this.close()
    },
    toggleSelection (item) {
      const index = this.checkedList.findIndex(i => i.id === item.id)
      if (index > -1) {
        this.checkedList.splice(index, 1)
      } else {
        this.checkedList.push(item)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.store-select {
  display: flex;
  flex-direction: column;
  height: 100%;
  .store-list-container {
    flex: 1;
    /deep/.van-cell {
      padding: 10px;
    }
  }
  .bottom-action {
    display: flex;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    .view-btn {
      background-color: #307bff;
    }
    .clear-btn {
      background-color: #fff;
      color: #c4200b;
    }
    .invite-btn {
      background-color: #307bff;
    }
    /deep/.van-button {
      border: none;
      border-radius: 0;
      .van-button__text {
        font-weight: bold;
      }
    }
  }
}
.picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: 0 16px;
  border-bottom: 1px solid #ebedf0;

  .cancel-btn {
    font-size: 14px;
    color: #969799;
    cursor: pointer;
  }

  .title {
    font-size: 16px;
    font-weight: 500;
    color: #323233;
  }

  .confirm-btn {
    font-size: 14px;
    color: #576b95;
    cursor: pointer;
    min-width: 40px; /* Placeholder width to center title */
  }
}

.store-list-container {
  height: calc(100% - 100px); /* Adjust based on header + search height */
  overflow-y: auto;
}

.store-main-content {
  font-size: 12px;
  .plan-name {
    width: 288px;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 3px;
  }
  .plan-info {
    width: 288px;
    color: #307bff;
    margin-bottom: 4px;
  }
  .plan-date {
    width: 288px;
    color: #7f7f7f;
  }
}
</style>
